import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Tooltip } from 'antd'
import Checkbox from '../Checkbox'
import Spinner from '../Spinner'

import './index.less'

class MergeDataConfig extends Component {
  static propTypes = {
    data: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
  }

  render() {
    const { no_merge_count, merge } = this.props.data
    return (
      <div>
        <div className="title">合并数据为其他
          <Checkbox
            data={merge}
            onChange={this.handleChangeMerge}
          />
        </div>
        {merge && <div className="layout-config-column">
          <div className="layout-config-column-title sub mergeDataSpinnerContainer" >
            显示前
            <Spinner
              style={{ width: '100px', display: 'inline-block' }}
              min={1}
              max={20}
              data={no_merge_count}
              unit={''}
              onChange={this.handleChangeNoMergeCount}
            />
            条数据，剩余合并为其他
            <Tooltip

              title="字段排序会影响最终显示效果">
              <span>
                <i className="iconfont icon-tip"
                  style={{ fontSize: '14px', color: '#FAAD14', verticalAlign: '-4%', marginRight: '5px' }}/>
              </span>
            </Tooltip>
          </div>
        </div>}
      </div>
    )
  }

  handleChangeMerge = () => {
    const { data, onChange } = this.props
    onChange({
      ...data,
      merge: !data.merge,
    })
  }

  handleChangeNoMergeCount = (d) => {
    const { data, onChange } = this.props
    onChange({
      ...data,
      no_merge_count: d,
    })
  }
}

export default MergeDataConfig
